<mat-nav-list>
  <mat-list-item (click)="openZombiePage()"> Страница зомби </mat-list-item>
  <mat-list-item (click)="openLogPage()"> Логи зомби </mat-list-item>
  <mat-list-item (click)="filterByZombie()"> В фильтр </mat-list-item>
</mat-nav-list>
